// extracted by mini-css-extract-plugin
export default {"view":"OptionSelector_view__FP682","header":"OptionSelector_header__HmwC-"};